;(function($, undefined){
    'use strict';

    var rnn = window.rnn,
        breakpoints = {'mobile': 767, 'tablet': 979};

    function init(){
        
        // Mobile
        enquire.register("(max-width: " + breakpoints.mobile + "px)", function() {
            var mobileEvent = $.Event('resize-mobile');
            mobileEvent.target = window;
            $(rnn).trigger(mobileEvent);
        });

        // Tablet
        enquire.register("(min-width: " + (breakpoints.mobile + 1) + "px) and (max-width: " + breakpoints.tablet + "px)", function() {
            var tabletEvent = $.Event('resize-tablet');
            tabletEvent.target = window;
            $(rnn).trigger(tabletEvent);    
        });

        // Desktop
        enquire.register("(min-width: " + (breakpoints.tablet + 1) + "px)", function() {
            var desktopEvent = $.Event('resize-desktop');
            desktopEvent.target = window;
            $(rnn).trigger(desktopEvent);
        });
    }

    rnn.modules.register('responsive', {
        init: init
    });

})(jQuery);

